import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";
import commonSwrConfig from "../commonSwrConfig";
import useSWR, { SWRResponse } from "swr";
import { IMorningstarSecurities } from "@portal/types/api/IMorningstarSecurities";
import { IUseMorningstarSecurities } from "./types";

const useMorningstarSecurities: IUseMorningstarSecurities = (isin?: string) => {
  const { update } = useSession();

  const { data, error, isLoading }: SWRResponse<IMorningstarSecurities, unknown> = useSWR(
    `/api/morningstar/securities/${isin}`,
    commonFetcher<IMorningstarSecurities>,
    commonSwrConfig(update),
  );
  return { data, error, isLoading };
};

export default useMorningstarSecurities;
